'use client';
import { useEffect } from 'react';
import { EVENT_BUS } from './bus.js';

const getInvalidationChannel = (__quid, strategy, data)=>{
    if (strategy === true) {
        return __quid;
    }
    return `${__quid}${strategy(data)}`;
};
const useInvalidationSubscriber = (__quid, persist, data, eventHandler)=>{
    useEffect(()=>{
        if (persist) {
            const channel = getInvalidationChannel(__quid, persist, data);
            return EVENT_BUS.on(channel, eventHandler);
        }
    }, [
        __quid,
        persist,
        data
    ]);
};

export { useInvalidationSubscriber };
//# sourceMappingURL=useInvalidationSubscriber.js.map
